export const TOP_MENU = {
  LABELS: ['Film', 'Documentary', 'Memorial', 'About'],
};

export const MEMORIAL = {
  TITLE: 'Memorial of the victims',
  INFO:
    'In memory of\u00a0the\u00a0deceased miners, for\u00a0their families and\u00a0relatives.',
  ALT1: 'Logo památníku obětí',
  ALT2: 'Ilustrace nočního dolu',
};

export const INFO = {
  ALT1: 'Logo Dukla 61',
  ALT2: 'Ilustrace dolu',
};

export const SPECIAL_BULLETS = {
  START: 'Introduction',
  END: 'Epilogue',
};

export const ALT = {
  BACK: 'Back',
};

export const COMPACT = {
  INFO:
    'For a\u00a0better experience, view the\u00a0page on\u00a0your computer.',
  INFO_BIG:
    'The page can be\u00a0switched to\u00a0an\u00a0interactive version by\u00a0turning the\u00a0device to\u00a0a\u00a0horizontal position.',
  ALT_TOP: 'Důl a logo',
  ALT_BTM: 'Důl - podzemí',
};



// WEBPACK FOOTER //
// ./src/texts.js